import { DefaultThunkAction } from "@/redux/util/type";
import { setIsLoading } from "@/redux/global/actions";
import {
	setUserInfoFetchFailure,
	setUserInfoFetchRequest,
	setUserInfoFetchSuccess,
} from "@/redux/user/actions";
import API from "@/api/serverCall";
import { UserResponseDto } from "@/api/interface";
import axios from "axios";
import { openErrorSnackbar } from "@/redux/notistack/actions";

export function getUserInfoRequestThunk(): DefaultThunkAction {
	return async (dispatch) => {
		dispatch(setIsLoading(true));
		dispatch(setUserInfoFetchRequest());

		try {
			const { data } = await API.get<UserResponseDto>({
				link: "/user",
			});

			dispatch(setUserInfoFetchSuccess(data));
			dispatch(setIsLoading(false));
		} catch (e) {
			dispatch(setUserInfoFetchFailure());
			if (axios.isAxiosError(e)) {
				dispatch(setIsLoading(false));
				dispatch(openErrorSnackbar("정보를 불러오지 못했습니다"));
			}
		}
	};
}
